import "./product.css";
import AddToCart from "../addToCart/AddToCart";
import { useState } from "react";

const Product = ({ product }) => {
  const { title, price, image,description } = product;
  const [showDescription , setShowDescription] = useState(false);

  function handleClick () {
    setShowDescription(!showDescription);
  }

  return (
    <div className="product-card">
      <div onClick={handleClick} className="product-img">
        <img src={image} alt="product" />
      </div>
      <div className="product-details">
        <h3 onClick={handleClick} className={"product-details-title"} >{title}</h3>
        {showDescription?<p className="product-details-description">{description}</p>:null}
        <div className="product-price-and-add-to-cart">
        <span>${price}</span>
        <AddToCart product={product} />
        </div>
      </div>
    </div>
  );
};

export default Product;
